import React from 'react';
import type { FieldValues, Path, PathValue } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';

import { Calendar } from './calendar';
import type { InputCalendarProps } from './types';

export function InputCalendar<T extends FieldValues = FieldValues>({
  control,
  className,
  helperText,
  inputProps,
  label,
  name,
  transformDates,
}: InputCalendarProps<T>) {
  return (
    <Controller<T>
      control={control}
      name={name}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl className={className} error={!!error} fullWidth>
          {typeof label === 'string' ? (
            <FormLabel component="legend">{label}</FormLabel>
          ) : (
            label
          )}

          <Calendar
            fullWidth
            multiple
            {...inputProps}
            value={value}
            onChange={(dates) => {
              let normalized;
              if (Array.isArray(dates)) {
                normalized = dates.flat();
              } else {
                normalized = dates ? [dates] : [];
              }
              let selectedDates =
                normalized
                  .filter((date) => date.isValid)
                  .map((date) => date.toDate())
                  .sort((a, b) => a.getTime() - b.getTime());
              selectedDates = transformDates?.(selectedDates) ?? selectedDates;
              onChange(selectedDates as PathValue<T, Path<T>>);
            }}
          />

          <FormHelperText>{error?.message || helperText}</FormHelperText>
        </FormControl>
      )}
    />
  );
}
